import React from 'react';
import './AlertBanner.css';

const AlertBanner = ({ showAlert, handleCancel, pendingApproval, handleSaveAndFeedback, handleConfirmCloseOrder, children, alertMessage, showSaveButton }) => {
  if (!showAlert) return null;

  return (
    <div className="banner">
      <button className="cancel-button" onClick={handleCancel}>X</button>
     
      <div className="banner-content">
        {alertMessage}
      </div>
      {showSaveButton && (
        <button className="save-button" onClick={handleSaveAndFeedback}>Save</button>
      )}
       {pendingApproval && (
        <button
          className="save-button"
          onClick={() => handleConfirmCloseOrder(pendingApproval.data)}
        >
          APPROVE
        </button>
      )}
    </div>
  );
};


export default AlertBanner;
